import React from 'react';

import useUuid from '../../../../hooks/useUuid';

type LineUpYellowRedCardAsComponentProps = {
  className?: string;
  key?: string;
};

const LineUpYellowRedCardAsComponent = ({ className, key }: LineUpYellowRedCardAsComponentProps) => {
  const uuid = useUuid();
  // eslint-disable-next-line sonarjs/no-nested-template-literals
  const uniqueIdentifier = `${uuid}${key ? `__${key}` : ''}`;

  return (
    <svg className={className} viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="-0.987341"
        y="-0.99992"
        width="8"
        height="11"
        rx="3"
        transform="matrix(1 0 -0.0126592 0.99992 2.10111 1.99992)"
        fill="#F20D0D"
        stroke="#14171F"
        strokeWidth="2"
      />
      <mask
        id={`line-up-yellow-yed-card-mask-${uniqueIdentifier}`}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="7"
        height="9"
      >
        <rect width="6" height="9" rx="2" transform="matrix(1 0 -0.0126592 0.99992 2.11377 2)" fill="#FFBF00" />
      </mask>
      <g mask={`url(#line-up-yellow-yed-card-mask-${uniqueIdentifier}`}>
        <path
          d="M8.11377 2L4.11377 2C3.0092 2 2.10243 2.89536 2.08845 3.99984L1.99984 10.9993L8.11377 2Z"
          fill="#FFBF00"
        />
      </g>
    </svg>
  );
};

export default LineUpYellowRedCardAsComponent;
